import React, { useState } from 'react';
import { FaRegUser } from "react-icons/fa6";
import { MdOutlineLock } from "react-icons/md";
import { FaRegEyeSlash, FaRegEye } from "react-icons/fa6";
import axios from 'axios';
import Cookies from 'js-cookie';
import { appText } from '../../texts';
import { API_URLS } from './../../urls';
import OtpLoginComponent from './OtpLoginComponent';
import { HiOutlineVideoCamera } from "react-icons/hi2";

const { loginText } = appText;

export default function LoginComponent({ onLoginSuccess }) {
    const [loginMethod, setLoginMethod] = useState('password');
    const [phoneNumber, setPhoneNumber] = useState('');
    const [password, setPassword] = useState('');
    const [showPassword, setShowPassword] = useState(false);
    const [errorMessage, setErrorMessage] = useState('');
    const [isLoading, setIsLoading] = useState(false);
    const isButtonDisabled = !phoneNumber || !password;

    const handlePhoneNumberChange = (e) => {
        const value = e.target.value.replace(/\D/g, '');
        if (value.length <= 11) {
            setPhoneNumber(value);
        }
    };

    const handlePasswordChange = (e) => {
        setPassword(e.target.value);
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (isButtonDisabled) return;
        if (!/^09\d{9}$/.test(phoneNumber)) {
            setErrorMessage("فرمت شماره موبایل نادرست است.");
            setTimeout(() => setErrorMessage(''), 5000);
            return;
        }
        setIsLoading(true);
        setErrorMessage('');
        try {
            const response = await axios.post(`${API_URLS.BASE_URL}auth/login_by_password`, {
                phone_number: phoneNumber,
                password: password,
            });

            const accessToken = response.data.access_token;
            const refreshToken = response.data.refresh_token;

            Cookies.set('access_token', accessToken, { expires: 1 });
            Cookies.set('refresh_token', refreshToken, { expires: 1 });
            Cookies.set('login_time', Date.now().toString());
            setIsLoading(false);
            onLoginSuccess();
            window.location.href = '/';
        } catch (error) {
            setIsLoading(false);
            if (error.response) {
                const { status, data } = error.response;
                if (status === 404) {
                    setErrorMessage("چنین کاربری وجود ندارد.");
                } else if (status === 422) {
                    setErrorMessage("رمز نادرست است.");
                } else if (status === 401) {
                    setErrorMessage("حساب کاربری شما هنوز فعال نشده است.");
                } else if (status === 400) {
                    setErrorMessage("رمز نادرست است.");
                } else {
                    setErrorMessage("خطای نامشخصی رخ داده است.");
                }
            } else {
                setErrorMessage("مشکلی در ارتباط با سرور پیش آمده است.");
            }
            setTimeout(() => setErrorMessage(''), 5000);
        }
    };

    return (
        <div className="flex flex-col w-full justify-center items-center">
            <img src="images/logo-bime.svg" alt="" className='my-5' />
            <div className="w-full md:w-1/2 flex flex-col items-center justify-center text-center rounded-lg py-6">
                <p className='text-center mb-10 text-secondary text-[24px]'>{loginText.loginData}</p>

                <p>نوع ورود به حساب کاربری</p>

                <div className="flex gap-4 my-4">
                    <label className="flex items-center gap-2">
                        <input
                            type="radio"
                            name="loginMethod"
                            value="password"
                            checked={loginMethod === 'password'}
                            onChange={() => setLoginMethod('password')}
                        />
                        رمز عبور
                    </label>
                    <label className="flex items-center gap-2">
                        <input
                            type="radio"
                            name="loginMethod"
                            value="otp"
                            checked={loginMethod === 'otp'}
                            onChange={() => setLoginMethod('otp')}
                        />
                        کد یکبار مصرف
                    </label>
                </div>
                {loginMethod === 'password' ? (
                    <>
                        <div className="w-full flex items-center justify-center text-center my-2">
                            <div className="relative w-4/5">
                                <FaRegUser className="absolute right-3 top-1/2 transform -translate-y-1/2 text-gray-500" />
                                <input
                                    className="w-full py-3 border border-solid border-primary rounded-[40px] pl-10 pr-9"
                                    type="text"
                                    placeholder={loginText.inputPlaceholder}
                                    value={phoneNumber}
                                    onChange={handlePhoneNumberChange}
                                />
                            </div>
                        </div>

                        <div className="w-full flex items-center justify-center text-center my-2">
                            <div className="relative w-4/5">
                                <MdOutlineLock className="absolute right-3 top-1/2 transform -translate-y-1/2 text-gray-500" />
                                <input
                                    className="w-full py-3 border border-solid border-primary rounded-[40px] pl-10 pr-10"
                                    type={showPassword ? 'text' : 'password'}
                                    placeholder={loginText.passPlaceholder}
                                    value={password}
                                    onChange={handlePasswordChange}
                                    onKeyDown={(e) => e.key === "Enter" && handleSubmit(e)}
                                />
                                <div
                                    className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-500 cursor-pointer"
                                    onClick={() => setShowPassword(!showPassword)}
                                >
                                    {showPassword ? <FaRegEyeSlash /> : <FaRegEye />}
                                </div>
                            </div>
                        </div>

                        {errorMessage && <p className="flex items-center py-2 pr-3 mt-1 w-4/5 text-warning">{errorMessage}</p>}

                        <div className="w-4/5 flex flex-col justify-center mt-4">
                            <button
                                type="submit"
                                disabled={isButtonDisabled || isLoading}
                                onClick={handleSubmit}
                                onKeyDown={(e) => e.key === "Enter" && handleSubmit(e)}
                                className={`w-full ${isButtonDisabled && !isLoading
                                    ? "bg-gray-400 cursor-not-allowed"
                                    : "bg-primary"
                                    } text-white rounded-[40px] border-none py-3 mt-1 flex items-center justify-center ${isLoading ? "cursor-not-allowed" : "cursor-pointer"
                                    }`}
                            >
                                {isLoading ? (
                                    <div className="w-5 h-5 animate-bounce">{loginText.btnLogin}</div>
                                ) : (
                                    <p>{loginText.btnLogin}</p>
                                )}
                            </button>
                            <div className='flex flex-col mt-5 items-center justify-between'>
                                <a className=" text-primary" href="/forget_password">
                                    {loginText.forgetPassword}</a>

                                <a
                                    href="/videos/login.mp4"
                                    download
                                    className="flex items-center gap-2 px-4 py-2 text-sm text-primary hover:bg-gray-100 hover:text-[#0061A8] hover:font-semibold transition"
                                >
                                    <HiOutlineVideoCamera className="text-lg" />
                                    نحوه ثبت نام و ورود به سامانه
                                </a>
                            </div>

                        </div>
                    </>
                ) : (
                    <OtpLoginComponent />
                )}
            </div>
        </div>
    );
}